import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  Typography,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import General from "./General.js";
import PaymentRequest from "./MaterialandPOPayment.js";
import PaymentDetailForm from "./SiteExpenditures.js";
import UPIpayment from "./UPI_payments.js";

function MainForm({ open, handleClose, initialFormData }) {
  const [selectedForm, setSelectedForm] = useState("SiteExpenditure");

  // console.log("initialFormData from main", initialFormData);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: isMobile ? "90%" : 600,
    maxHeight: "80vh",
    bgcolor: "background.paper",
    borderRadius: 2,
    boxShadow: 24,
    p: isMobile ? 2 : 4,
    overflowY: "auto",
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  };

  const headerStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mb: 2,
  };

  const closeButtonStyle = {
    color: "text.primary",
    ":hover": {
      bgcolor: "action.hover",
    },
  };

  const selectStyle = {
    marginTop: 2,
    marginBottom: 2,
  };

  // Update form selection based on `initialFormData`
  useEffect(() => {
    if (initialFormData) {
      console.log("initialFormData", initialFormData.payment_type);
      
      let formName = "";
      switch (initialFormData.payment_type) {
        case "Site Expenditure":
          formName = "SiteExpenditure";
          break;
        case "Material and PO Payment":
          formName = "MaterialandPOPayment";
          break;
        case "General":
          formName = "General";
          break;
        case "UPI payment":
          // formName = "UPIpayment";
          formName = "UPI payment";
          break;
        default:
          formName = "SiteExpenditure";
      }
      setSelectedForm(formName);
    } else {
      setSelectedForm("SiteExpenditure");
    }
  }, [initialFormData]);

  const handleFormChange = (event) => {
    setSelectedForm(event.target.value);
  };

  const isValidEditData =
    initialFormData &&
    typeof initialFormData === "object" &&
    !Array.isArray(initialFormData) &&
    initialFormData !== null &&
    Object.keys(initialFormData).length > 0;
  // console.log("isValidEditData", isValidEditData);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={modalStyle}>
        <Box sx={headerStyle}>
          <Typography id="modal-title" variant="h6" component="h2">
            {isValidEditData ? "Edit Request" : "New Request"} Form
          </Typography>
          <IconButton
            sx={closeButtonStyle}
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <FormControl fullWidth sx={selectStyle}>
          <InputLabel id="form-select-label">Select Form</InputLabel>
          <Select
            labelId="form-select-label"
            value={selectedForm}
            onChange={handleFormChange}
            variant="outlined"
            color="primary"
            disabled={isValidEditData}
          >
            <MenuItem value="SiteExpenditure">Site Expenditures</MenuItem>
            <MenuItem value="MaterialandPOPayment">
              Material and PO Payment
            </MenuItem>
            <MenuItem value="General">General</MenuItem>
            <MenuItem value="UPI payment">UPI Payment</MenuItem>
          </Select>
        </FormControl>
        <Box sx={{ mt: 2 }}>
          {selectedForm === "SiteExpenditure" && (
            <PaymentDetailForm
              initialFormData={isValidEditData ? initialFormData : {}}
              handleClose={handleClose}
            />
          )}
          {selectedForm === "MaterialandPOPayment" && (
            <PaymentRequest
              initialFormData={isValidEditData ? initialFormData : {}}
              handleClose={handleClose}
            />
          )}
          {selectedForm === "General" && (
            <General
              initialFormData={isValidEditData ? initialFormData : {}}
              handleClose={handleClose}
            />
          )}
          {selectedForm === "UPI payment" && (
            <UPIpayment
              initialFormData={isValidEditData ? initialFormData : {}}
              handleClose={handleClose}
            />
          )}
        </Box>
      </Box>
    </Modal>
  );
}

export default MainForm;
